/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Seating_HintInputs */



/**
* | output |
* | --- |
* | "Order the seats as the finalists sat, then enter their VPs." |
*
* @param {League_Final_Seating_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_seating_hint = /** @type {((inputs?: League_Final_Seating_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Seating_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ordonnez les places comme les finalistes se sont assis, puis saisissez leurs VP.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordena los asientos como se sentaron los finalistas y luego introduce sus VP.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ordene os assentos como os finalistas se sentaram e depois informe os VP.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina i posti come si sono seduti i finalisti, poi inserisci i loro VP.")
	return /** @type {LocalizedString} */ ("Order the seats as the finalists sat, then enter their VPs.")
});